<template>
  <modal
    class="modal"
    name="set-email-modal"
    transition="pop-out"
    :width="modalWidth"
    :height="260"
    :adaptive="true"
    :clickToClose="false"
    @before-open="beforeOpen"
  >
    <div class="flex flex-column items-center justify-center w-100 h-100">
      <div class="flex justify-end w-100 mt-2">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times" size="2x" />
        </a>
      </div>

      <div class="h2 heigthMobile">
        <clip-loader :loading="isLoadingLink" :color="color" :size="size"></clip-loader>
      </div>

    <div class="custom-padding">
      <div class="text-center mb-3">
        <p class="w-100 tc textColor">{{ $t("users.subscription.infoEmailNeeded1") }}</p>
          <div class="custom-padding-input">
            <input
              type="email"
              id="email"
              v-model="emailNeeded"
              maxlength="200"
              class="form-control dark-text-color"
              @input="validateEmail"
            />
          </div>
        <p v-if="emailError" class="error">{{ emailError }}</p>
        <p class="w-100 tc textColor">{{ $t("users.subscription.infoEmailNeeded2") }}</p>
      </div>
    </div>

      <div class="mb-4 flex items-center flex-wrap justify-center">
        <button
          @click="getSubsLink('mercadopago')"
          :disabled="disabled"
          class="w-90 block mv2 pointer btn dim b f5 fw4"
          :class="{ 'disabled': disabled }"
        >
          {{ $t("users.subscription.sendEmailNeeded") }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import {mapActions, mapGetters} from 'vuex'

  const MODAL_WIDTH = 600

  export default {
    name: 'set-email-modal',
    components: {
      FontAwesomeIcon,
      ClipLoader
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '30px',
        paymentUrl: '',
        emailNeeded: '',
        email: '',
        currency: 'ARS',
        disabled: false,
        tab: null,
        providerCountry: null,
        voucher: null,
        ppPlan: null,
        suggestedValues: null,
        index: null,
        valueARS: 0,
        valueUSD: 0,
        message: '',
        refCode: null,
        gateway: null,
        emailError: ''
      }
    },
    computed: {
      isLoadingLink () {
        return this.$loading.isLoading('user getSubscriptionLink')
      },
      ...mapGetters('user', [
        'user'
      ]),
      ...mapGetters('pricing', [
        'pricing'
      ])
    },
    created () {
      this.providerCountry = localStorage.getItem('providerCountry')
      this.getPPplans().then((plans) => {
        if (plans) {
          this.ppPlan = plans[0]
        }
      })
    },
    methods: {
      ...mapActions('user', [
        'getSubscriptionLink'
      ]),
      ...mapActions('home', [
        'getPPplans'
      ]),
      closeModal () {
        this.valueARS = 0
        this.valueUSD = 0
        localStorage.removeItem('userFromLandingMK')
        this.$modal.hide('set-email-modal')
      },
      beforeOpen (event) {
        this.disabled = false
        this.emailError = ''
        this.emailNeeded = this.user.email
        this.paymentUrl = event.params.paymentUrl
        this.voucher = event.params.voucher
        this.refCode = event.params.refCode
        this.gateway = event.params.gateway
        this.valueARS = 0
        this.valueUSD = 0
      },
      getSubsLink (gateway) {
        this.disabled = true
        this.getSubscriptionLink({gateway: gateway, paymentUrl: this.paymentUrl, voucher: this.voucher, refCode: this.refCode, emailNeeded: this.emailNeeded}).then(nextUrl => {
          window.location.href = nextUrl
        }).catch(e => {
          if (e.message === 'Ya se encuentra una suscripción activa para este usuario') {
            localStorage.removeItem('userFromLandingMK')
            this.$modal.hide('set-email-modal')
            this.disabled = false
            this.$router.push({path: '/home'})
          }
          if (e.message === 'Invalid Voucher Code') {
            this.$modal.hide('set-email-modal')
          }
          this.$toasted.show(e.message, {type: 'error'})
          this.disabled = false
        })
      },
      validateEmail () {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(this.emailNeeded)) {
          this.emailError = 'Correo electrónico no válido'
          this.disabled = true
        } else {
          this.emailError = ''
          this.disabled = false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .modal {
    z-index: 10000;
  }

  .custom-padding {
  padding-left: 1rem;
  padding-right: 1rem;
}

.custom-padding-input {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width:300px) and (max-width:600px) {
  .heigthMobile{
    height: 0px !important;
  }
}

.error {
  color: red;
}

.dark-text-color {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/SetEmailModal.vue